export default {
  "Standardized Runoff Index-30 Day Cumulative": "_zscore",
  "Standardized Runoff Index-60 Day Cumulative": "_zscore",
  "Standardized Runoff Index-90 Day Cumulative": "_zscore",
  "Standardized Runoff Index-180 Day Cumulative": "_zscore",
  "Standardized Runoff Index-365 Day Cumulative": "_zscore",
  "Standardized Runoff Index-Annual Cumulative": "_zscore",
  "Water Spread Area-Average": "_wsa_avg",
  "Water Spread Area-Standard Deviation": "_wsa_deviation",
  "Standardized Groundwater Level Index-Telangana": "_zscore",
  "Standardized Reservoir Storage Index-reservoir": "_zscore",

  "Standardized Water Spread Index-#": "_zscore",
};
